// Minimal DOM helper. h('div.foo#bar', { onclick }, ['child', h('span', {}, 'x')])
// Keeps UI files declarative without pulling in a framework.

const TAG_RE = /^([a-zA-Z][a-zA-Z0-9-]*)?(?:#([\w-]+))?((?:\.[\w-]+)*)$/;

export function h(tagSpec, props = {}, children = []) {
    const m = TAG_RE.exec(tagSpec);
    if (!m) throw new Error(`bad tag spec: ${tagSpec}`);
    const tag = m[1] || 'div';
    const id = m[2];
    const cls = (m[3] || '').split('.').filter(Boolean);

    const el = document.createElement(tag);
    if (id) el.id = id;
    if (cls.length) el.className = cls.join(' ');

    for (const [k, v] of Object.entries(props)) {
        if (v == null || v === false) continue;
        if (k === 'class') el.className = [el.className, v].filter(Boolean).join(' ');
        else if (k === 'style' && typeof v === 'object') Object.assign(el.style, v);
        else if (k === 'dataset') Object.assign(el.dataset, v);
        else if (k.startsWith('on') && typeof v === 'function') {
            el.addEventListener(k.slice(2).toLowerCase(), v);
        } else if (k in el && typeof el[k] !== 'function') {
            el[k] = v;
        } else {
            el.setAttribute(k, v === true ? '' : String(v));
        }
    }

    appendAll(el, children);
    return el;
}

function appendAll(parent, children) {
    if (children == null || children === false) return;
    if (Array.isArray(children)) { children.forEach(c => appendAll(parent, c)); return; }
    if (children instanceof Node) { parent.appendChild(children); return; }
    parent.appendChild(document.createTextNode(String(children)));
}

export function clear(node) {
    while (node.firstChild) node.removeChild(node.firstChild);
}

export function on(el, event, handler) {
    el.addEventListener(event, handler);
    return () => el.removeEventListener(event, handler);
}

export function $(selector, root = document) { return root.querySelector(selector); }
export function $$(selector, root = document) { return Array.from(root.querySelectorAll(selector)); }
